"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const ThirdPartiesBanner_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/ThirdPartiesBanner.vue"));
const ThirdPartiesModal_vue_1 = __importDefault(require("@becrop/components/Common/ThirdParties/ThirdPartiesModal.vue"));
const ThirdPartiesManager_1 = __importDefault(require("@becrop/components/Common/ThirdParties/Abstract/Controllers/ThirdPartiesManager"));
const Provider_1 = require("@becrop/components/Common/ThirdParties/Abstract/Models/Provider");
let ThirdPartiesPackage = class ThirdPartiesPackage extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.thirdPartiesController = new ThirdPartiesManager_1.default(this.leafUserId);
        this.isModalDeployed = false;
        this.isConnection = true;
        this.activeStage = 'list';
        this.activeProvider = new Provider_1.Provider({});
    }
    deployModal() {
        this.isModalDeployed = true;
    }
    dismissModal() {
        this.isModalDeployed = false;
        this.activeStage = 'list';
    }
    backToList() {
        this.activeStage = 'list';
    }
    afterConnection() {
        this.backToList();
    }
    toggleModal() {
        this.isModalDeployed = !this.isModalDeployed;
    }
    providers() {
        return this.thirdPartiesController.providers;
    }
    isFetching() {
        return this.thirdPartiesController.isFetching;
    }
    get activeProviderAreas() {
        return this.thirdPartiesController.activeProviderAreas;
    }
    async confirmConnection(p) {
        this.activeProvider = p;
        this.isConnection = true;
        this.activeStage = 'bridge';
        await this.thirdPartiesController.connectProvider(p);
        //setTimeout(() => { this.activeStage = 'success' }, 2000);  
    }
    async connectProvider(p) {
        this.activeProvider = p;
        if (this.hasDisclaimer) {
            this.activeStage = 'disclaimer';
        }
        else {
            this.confirmConnection(p);
        }
    }
    async confirmDisconnection(p) {
        this.activeProvider = p;
        this.isConnection = false;
        this.activeStage = 'bridge';
        const res = await this.thirdPartiesController.disconnectProvider(p);
        this.activeStage = 'list';
        //setTimeout(() => { this.activeStage = 'error' }, 2000);
    }
    disconnectProvider(p) {
        this.activeProvider = p;
        this.activeStage = 'warning';
    }
    async addSelected(b, m, a) {
        this.activeStage = 'importingData';
        await this.thirdPartiesController.addSelected(b, m, a);
        this.dismissModal();
    }
    async mounted() {
        await this.thirdPartiesController.fetchProvidersList();
        this.thirdPartiesController.checkIfRedirected();
        if (this.thirdPartiesController.comesFromRedirection) {
            this.deployModal();
            this.activeProvider = this.thirdPartiesController.redirectedProvider;
            if (this.activeProvider.linked) {
                this.activeStage = 'success';
            }
            else {
                this.activeStage = 'error';
            }
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], ThirdPartiesPackage.prototype, "leafUserId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ThirdPartiesPackage.prototype, "hasTriggeringBanner", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ThirdPartiesPackage.prototype, "hasDisclaimer", void 0);
ThirdPartiesPackage = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ThirdPartiesBanner: ThirdPartiesBanner_vue_1.default,
            ThirdPartiesModal: ThirdPartiesModal_vue_1.default
        }
    })
], ThirdPartiesPackage);
exports.default = ThirdPartiesPackage;
